import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { KYMW1400Model } from '../kymw1400.model';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { KYMW1400KomaPageModule } from '../kymw1400-koma-page/kymw1400-koma-page.module';

import { KYMW1400KomaPageLeftComponent } from './kymw1400-koma-page-left.component';


/**
 * コマ割（左ページ） モジュール設定クラス
 *
 * @export KYMW1400KomaPageLeftModule
 * @class KYMW1400KomaPageLeftModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW1400KomaPageModule
  ],
  declarations: [
    KYMW1400KomaPageLeftComponent,
  ],
  providers: [
    KYMW1400Model,
  ],
  exports: [
    KYMW1400KomaPageLeftComponent,
  ]
})
export class KYMW1400KomaPageLeftModule {
}
